// extracted by mini-css-extract-plugin
export default {"foodBase":"styles_foodBase__2+T7a","active":"styles_active__y6QvW","foodItem":"styles_foodItem__SvBv7","extension":"styles_extension__yNIkV"};